import React from "react";
import { COLORS } from "./worldMonitorData";

export function openSource(url) {
  if (url) window.open(url, "_blank", "noopener,noreferrer");
}

export function Badge({ children, tone = "gray" }) {
  const palette = {
    red: { bg: "#8e0711", fg: "#fff" },
    green: { bg: "rgba(0,217,120,0.14)", fg: COLORS.green },
    amber: { bg: "rgba(255,159,26,0.18)", fg: COLORS.orange },
    yellow: { bg: "rgba(255,211,42,0.18)", fg: COLORS.yellow },
    blue: { bg: "rgba(42,168,255,0.18)", fg: COLORS.blue },
    purple: { bg: "rgba(141,108,255,0.18)", fg: COLORS.purple },
    gray: { bg: "#202020", fg: COLORS.text2 },
  };
  const p = palette[tone] || palette.gray;

  return (
    <span
      className="inline-flex items-center rounded-sm px-2 py-1 text-[10px] font-black uppercase tracking-wide"
      style={{ background: p.bg, color: p.fg, border: `1px solid ${p.fg}33` }}
    >
      {children}
    </span>
  );
}

export function SectionPanel({ title, children, right, className = "", bodyClassName = "", style }) {
  return (
    <section
      className={`min-h-[160px] overflow-hidden ${className}`}
      style={{
        background: `linear-gradient(90deg, ${COLORS.panel} 0%, ${COLORS.panel} 78%, #07101a 100%)`,
        border: `1px solid ${COLORS.border}`,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.55)",
        ...style,
      }}
    >
      <div className="flex min-h-[44px] items-center justify-between gap-3 border-b px-3" style={{ borderColor: COLORS.border }}>
        <div className="flex items-center gap-2">
          <h3 className="font-mono text-sm font-black uppercase tracking-[0.18em]" style={{ color: COLORS.text }}>
            {title}
          </h3>
          <span className="inline-flex h-5 w-5 items-center justify-center rounded-full border text-[11px]" style={{ borderColor: COLORS.border, color: COLORS.text2 }}>
            ?
          </span>
        </div>
        <div className="flex items-center gap-2">{right}</div>
      </div>
      <div className={`p-3 ${bodyClassName}`}>{children}</div>
    </section>
  );
}

export function Sparkline({ points = [40, 44, 42, 46, 50, 48, 54], color = COLORS.green, height = 38 }) {
  const max = Math.max(...points);
  const min = Math.min(...points);
  const span = max - min || 1;
  const poly = points
    .map((point, index) => {
      const x = (index / (points.length - 1)) * 100;
      const y = 100 - ((point - min) / span) * 88 - 6;
      return `${x},${y}`;
    })
    .join(" ");

  return (
    <svg viewBox="0 0 100 100" style={{ height, width: "100%" }} preserveAspectRatio="none">
      <polyline fill="none" stroke={color} strokeWidth="4" points={poly} />
    </svg>
  );
}

export function formatUtc(date) {
  return date
    .toLocaleString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "UTC",
      hour12: false,
    })
    .replace(",", "")
    .toUpperCase() + " UTC";
}
